import { HANDS_UP_TYPES } from '@/modules/Account/interface/HANDS_UP_TYPES';
import { envConfig } from './env';

export const salesforceConfig = {
  instanceUrl: 'https://euqueroinvestir.my.site.com',
  salesforceChat: {
    isAvailable: true,
    chatName: envConfig.salesforce.chat.chatName,
    queueId: envConfig.salesforce.chat.queueId,
    queueName: envConfig.salesforce.chat.queueName,
    scrt2URL: 'https://euqueroinvestir.my.salesforce-scrt.com',
  },
};

export const salesforceOpportunityConfig = {
  FP: {
    myGoals: {
      default: {
        action: HANDS_UP_TYPES.FP,
        product: 'Meus_Objetivos_FP',
        description: 'Preciso de ajuda',
      },
      empty: {
        action: HANDS_UP_TYPES.FP,
        product: 'Conversar_FP',
        description: 'Gostaria de cadastrar meus objetivos',
      },
      newContribuition: {
        action: HANDS_UP_TYPES.FP,
        product: 'Realizar_Aporte_FP',
        description: 'Gostaria de fazer um novo aporte',
      },
      talkWithPlanner: {
        action: HANDS_UP_TYPES.FP,
        product: 'Cadastrar_Objetivos_FP',
        description: 'Falar com o planejador',
      },
    },
    myNetWorth: {
      imobilized: {
        talkWithPlanner: {
          action: HANDS_UP_TYPES.FP,
          product: 'Conversar_Assessor_Patrimonio_FP',
          description: 'Gostaria de adicionar um bem imobilizado',
        },
      },
    },
    myRetirement: {
      empty: {
        action: HANDS_UP_TYPES.FP,
        product: 'Simular_Aposentadoria_FP',
        description: 'Quero cenários de aposentadoria',
      },
    },
    fpHub: {
      opportunity: {
        action: HANDS_UP_TYPES.FP,
        product: 'Conversar_Assessor_FP',
        description: 'Gostaria de conhecer o Planejador Financeiro',
      },
    },
    patrimonialProtection: {
      opportunity: {
        action: HANDS_UP_TYPES.FP,
        product: 'Conversar_Assessor_Patrimonial_Protection_FP',
        description: 'Gostaria de conhecer o Planejador Financeiro',
      },
    },
    financialControl: {
      opportunity: {
        action: HANDS_UP_TYPES.FP,
        product: 'Conversar_Assessor_Financial_Control_FP',
        description: 'Gostaria de conhecer o Planejador Financeiro',
      },
    },
  },
  banking: {
    business: {
      credit: {
        action: HANDS_UP_TYPES.Empresarial_Credito,
        product: 'Credito_Empresarial',
      },
      freeMarket: {
        action: HANDS_UP_TYPES.Empresarial_Energia,
        product: 'Mercado_Energia',
      },
    },
    content: {
      action: HANDS_UP_TYPES.Abertura_Conta,
      product: 'Abrir_Conta_Research',
    },
    news: {
      action: HANDS_UP_TYPES.Abertura_Conta,
      product: 'Abrir_Conta_Noticias',
    },
    creditCard: {
      action: HANDS_UP_TYPES.Cartoes,
      product: 'Cartao_Crédito',
    },
    exchange: {
      action: HANDS_UP_TYPES.Cambio,
      product: 'Simular_Cambio',
    },
    goodsAcquisition: {
      realEstateFinancing: {
        action: HANDS_UP_TYPES.Aquisicao_de_bens_Financiamento,
        product: 'Financiamento_PF',
      },
      homeEquity: {
        action: HANDS_UP_TYPES.Aquisicao_de_bens_Home_Equity,
        product: 'Home_Equity',
      },
      consortium: {
        action: HANDS_UP_TYPES.Aquisicao_de_bens_Consorcio,
        product: 'Simular_Consorcio',
      },
    },
    invest: {
      action: HANDS_UP_TYPES.Boletador,
      product: 'Comprar/Vender_Consolidador',
    },
    lifeInsurance: {
      action: HANDS_UP_TYPES.Seguros,
      product: 'Seguro_Vida',
    },
    openAccount: {
      action: HANDS_UP_TYPES.Abertura_Conta,
      product: 'Abrir_Conta',
    },
    pension: {
      action: HANDS_UP_TYPES.Previdencia,
      product: 'Simular_Previdencia',
    },
    variableIncome: {
      opportunity: {
        action: HANDS_UP_TYPES.RV,
        product: 'Renda_Variavel',
      },
      openAccount: {
        action: HANDS_UP_TYPES.Abertura_Conta,
        product: 'Abrir_Conta_Renda_Variavel',
      },
    },
    LiveOffPassiveIncome: {
      openAccount: {
        action: HANDS_UP_TYPES.Vivendo_de_renda_EQI_account,
        product: 'Vivendo de renda EQI+',
      },
      advisory: {
        action: HANDS_UP_TYPES.Vivendo_de_renda_EQI_Advisory,
        product: 'Vivendo de renda EQI+',
      },
    },
  },
  sendClickEvent: {
    welcome: {
      label: (label: string) => `Bem Vindo|${label}`,
    },
    sideMenu: {
      label: (label: string) => `Menu|${label}`,
    },
    bannerCarrouselCourseMovies: {
      label: (label: string, url: string) => `${label}|${url}`,
    },
    recommnendation: {
      label: (label: string, url: string) => `${label}|${url}`,
    },
    myAdvisor: {
      label: (url: string) => `Fale com o assessor|${url}`,
    },
    myAdvisorIsClient: {
      label: (label: string, url: string) => `${label}|${url}`,
    },
    researchContent: {
      label: (label: string, url: string) => `${label}|${url}`,
    },
    invest: {
      label: (label: string, url: string) => `${label}|${url}`,
    },
    openAccount: {
      label: (url: string) => `Abra sua conta na EQI|${url}`,
    },
    lifeInsurance: {
      label: (label: string, url: string) => `${label}|${url}`,
    },
    variableIncomeAdvisor: {
      label: (label: string, url: string) => `${label}|${url}`,
    },
    BusinessCredit: {
      label: (label: string, url: string) => `${label}|${url}`,
    },
    freeMarket: {
      label: (label: string, url: string) => `${label}|${url}`,
    },
    creditCard: {
      label: (label: string, url: string) => `${label}|${url}`,
    },
    exchange: {
      label: (label: string, url: string) => `${label}|${url}`,
    },
    goodsAquisition: {
      label: (label: string, url: string) => `${label}|${url}`,
    },
    homeEquity: {
      label: (label: string, url: string) => `${label}|${url}`,
    },
    realEstateFinancing: {
      label: (label: string, url: string) => `${label}|${url}`,
    },
    exclusiveServices: {
      label: (label: string) => label,
    },
    myPrivatePension: {
      label: (label: string, url: string) => `${label}|${url}`,
    },
    privatePensionNotCustomer: {
      label: (label: string, url: string) => `${label}|${url}`,
    },
    privatePension: {
      simulateButton: 'Prev|Simular_Minha_Previdencia',
      openAccount: 'Prev|Abrir_Conta',
      invest: 'Prev|Investir_Prev',
      anotherSimulation: 'Prev|Realizar_Outra_Simulacao',
    },
    supplementaryMaterial: {
      label: (label: string) => `Material Suplem|${label}`,
    },
    search: {
      label: (label: string) => `Busca|${label}`,
    },
    contribuition: {
      label: (label: string) => `Fazer novo aporte|${label}`,
    },
  },
  myAdvisory: {
    action: HANDS_UP_TYPES.Minha_Assessoria,
    product: 'Conversar_Minha_Assessoria',
  },
  myRetirement: {
    action: HANDS_UP_TYPES.Previdencia,
    product: 'Conversar_Minha_Previencia',
  },
  investment: {
    hub: {
      action: HANDS_UP_TYPES.Investimentos,
      product: 'Conversar_Investimentos',
    },
    cetipado: {
      action: HANDS_UP_TYPES.Investimentos,
      product: 'Sec_Cetipados_Investir',
    },
    secundaries: {
      action: HANDS_UP_TYPES.Investimentos,
      product: 'Sec_Produtos_Investir',
    },
    wallet: {
      action: HANDS_UP_TYPES.Investimentos,
      product: 'Sec_Carteira_Investir',
    },
  },
  retrospective: {
    fp: 'Retrospectiva|Preencher planejamento',
    see: 'Retrospectiva|Ver retrospectiva',
  },
  cirque: {
    see: {
      label: 'Cirque|Saiba mais',
    },
  },
};
